import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import React from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { EProjectStatus } from '../../../../shared/enums/projects/EProjectStatus';
import { EProjectType } from '../../../../shared/enums/projects/EProjectType';
import { handleError } from '../../../../shared/functions/handleError';
import { IProject } from '../../../../shared/interfaces/projects/IProject';
import { AdminProjectsService } from '../service';
import ProjectForm from './ProjectForm';

export const projectSchema = yup.object().shape({
  name: yup.string().required('validation.required'),
  description: yup
    .string()
    .required('validation.required')
    .min(3, 'validation.minLength'),
  status: yup
    .mixed<EProjectStatus>()
    .oneOf(Object.values(EProjectStatus))
    .required('validation.required'),
  projectType: yup
    .array()
    .of(yup.mixed<EProjectType>().oneOf(Object.values(EProjectType)))
    .min(1, 'validation.minLength')
    .required('validation.required'),

  clientId: yup.number().required('validation.required'),
  userIds: yup.array().of(yup.number()).required('validation.required'),
});
const ProjectCreate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { handleSubmit, control, watch, getValues, setValue } =
    useForm<IProject>({
      resolver: yupResolver(projectSchema) as unknown as Resolver<IProject>,
    });

  const submitHandler = (formData: IProject) => {
    AdminProjectsService.create(formData)
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t('toasts.successfullyCreated', { title: formData?.name }),
            {
              variant: 'success',
            },
          );
        }
      })
      .catch((err) => handleError(err));
  };
  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <ProjectForm
        control={control}
        watch={watch}
        project={getValues()}
        setValue={setValue}
      />
    </form>
  );
};

export default ProjectCreate;
